import TYPES from '../../types';

// Domain
import {
  CustomGoalTypesRepository,
} from '@/modules/flagship/catalogs/custom-goal-types/domain/repositories/custom-goal-types-repository';
import {
  CustomGoalTypesEntity,
} from '@/modules/flagship/catalogs/custom-goal-types/domain/entities/custom-goal-types-entity';
import { CustomGoalTypesStateManager } from '@/modules/flagship/catalogs/custom-goal-types/domain/state/custom-goal-types-state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class GetCustomGoalTypesQuery
  extends Query<Promise<Array<CustomGoalTypesEntity>>> {
  @Inject(TYPES.CUSTOM_GOAL_TYPES_REPOSITORY)
  private readonly repository!: CustomGoalTypesRepository;

  @Inject(TYPES.CUSTOM_GOAL_TYPES_STATE_MANAGER)
  private readonly state_manager!: CustomGoalTypesStateManager;

  internalExecute(): Promise<Array<CustomGoalTypesEntity>> {
    return new Promise((resolve, reject) => {
      if (this.state_manager.state.loaded) {
        resolve(this.state_manager.state.items);
      } else {
        this.repository.get()
          .then((items) => {
            this.state_manager.patch({ items, loaded: true });
            resolve(items);
          })
          .catch(reject);
      }
    });
  }
}
